import React from 'react';

const AppItem = ({ title, tags, usage, isDarkMode, onUse }) => {
  const handleUse = () => {
    if (typeof onUse === 'function') {
      onUse();
    } else {
      console.log(`Using ${title}`);
    }
  };

  return (
    <div
      className={`rounded-xl overflow-hidden shadow-sm border flex items-center
        transition-all duration-200 hover:-translate-y-0.5 hover:shadow-md ${
          isDarkMode
            ? 'bg-[#1F2023] border-gray-600 shadow-black shadow-opacity-30'
            : 'bg-white border-gray-200 shadow-gray-900 shadow-opacity-10'
        }`}
    >
      <div
        className={`w-2.5 h-full rounded-l-xl ${
          isDarkMode ? 'bg-purple-600' : 'bg-gray-900'
        }`}
      />

      <div className="p-4 flex-grow">
        <h3
          className={`text-lg font-semibold mb-2.5 ${
            isDarkMode ? 'text-white' : 'text-gray-900'
          }`}
        >
          {title}
        </h3>
        <div className="flex flex-wrap gap-1.5 mb-2.5">
          {tags.map((tag, idx) => (
            <span
              key={idx}
              className={`px-2 py-0.5 rounded text-xs ${
                isDarkMode ? 'bg-gray-700 text-gray-300' : 'bg-gray-50 text-gray-600'
              }`}
            >
              {tag}
            </span>
          ))}
        </div>
        <p className={`text-xs opacity-80 ${
          isDarkMode ? 'text-gray-400' : 'text-gray-500'
        }`}>
          {usage}
        </p>
      </div>

      <div className="ml-auto mr-4">
        <button
          onClick={handleUse}
          className={`text-xs font-medium px-4 py-2 rounded-full border-none cursor-pointer transition-colors duration-200 ${
            isDarkMode
              ? 'bg-gray-700 text-white hover:bg-gray-600'
              : 'bg-gray-50 text-gray-900 hover:bg-gray-100'
          }`}
        >
          Use
        </button>
      </div>
    </div>
  );
};

export default AppItem;
